import { digitsOnly, normalizeCep, normalizeCpfCnpj, normalizePhone } from '@ck/domain'

export interface RegisterFormValues {
  name: string
  email: string
  phone: string
  cpfCnpj: string
  cep: string
  password: string
  confirmPassword: string
}

export interface RegisterFormErrors {
  name?: string[]
  email?: string[]
  phone?: string[]
  cpfCnpj?: string[]
  cep?: string[]
  password?: string[]
  confirmPassword?: string[]
}

export function validateName(name: string): string[] {
  return name.trim().length < 3 ? ['Nome deve ter ao menos 3 caracteres.'] : []
}

export function validateEmail(email: string): string[] {
  return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim()) ? [] : ['E-mail inválido.']
}

export function validatePhone(phone: string): string[] {
  if (!phone.trim()) return []
  const normalized = normalizePhone(phone)
  return !normalized || digitsOnly(phone).length !== 13
    ? ['Telefone deve seguir o formato +00 (00) 00000-0000.']
    : []
}

export function validateCpfCnpj(cpfCnpj: string): string[] {
  if (!cpfCnpj.trim()) return []
  return normalizeCpfCnpj(cpfCnpj) ? [] : ['CPF/CNPJ inválido.']
}

export function validateCep(cep: string): string[] {
  if (!cep.trim()) return []
  return normalizeCep(cep) ? [] : ['CEP deve ter 8 dígitos.']
}

export function validatePassword(password: string): string[] {
  if (password.length < 8) return ['Senha deve ter ao menos 8 caracteres.']
  return /\d/.test(password) ? [] : ['Senha deve conter ao menos um dígito.']
}

export function validateConfirmPassword(password: string, confirmPassword: string): string[] {
  return password === confirmPassword ? [] : ['As senhas não coincidem.']
}

export function validateRegisterForm(values: RegisterFormValues): RegisterFormErrors {
  const errors: RegisterFormErrors = {}
  const name = validateName(values.name)
  if (name.length) errors.name = name
  const email = validateEmail(values.email)
  if (email.length) errors.email = email
  const phone = validatePhone(values.phone)
  if (phone.length) errors.phone = phone
  const cpfCnpj = validateCpfCnpj(values.cpfCnpj)
  if (cpfCnpj.length) errors.cpfCnpj = cpfCnpj
  const cep = validateCep(values.cep)
  if (cep.length) errors.cep = cep
  const password = validatePassword(values.password)
  if (password.length) errors.password = password
  const confirmPassword = validateConfirmPassword(values.password, values.confirmPassword)
  if (confirmPassword.length) errors.confirmPassword = confirmPassword
  return errors
}
